import { usePermissions } from "./usePermissions";
import { useQPSearch } from "./useQPSearch";

export const usePermsAssets = (action: WDPermsAsset, skipSearch = false) => {
  const { assets } = usePermissions();
  const { searchState } = useQPSearch();

  return assets.includes(action) || (skipSearch && !!searchState);
};
